// @ts-nocheck
import { node } from "~/util/dom";
import createSDSIcon from "~/ui/icon";
import { PLUS_24 } from "@sznds/icons";
import { ICON_REMOVE_24 } from "~/ui/icons";

type TOnZoom = (direction: number) => void;

export default class ControlZoom {
	_onZoom: TOnZoom;

	_zoomOutButton: HTMLMapyMapButtonElement;

	_zoomInButton: HTMLMapyMapButtonElement;

	constructor({
		onZoom = () => {},
	}: {
		onZoom: TOnZoom;
	}) {
		const zoomGroup = node("mapy-map-button-group", { className: "gallery-zoom" });

		this._zoomOutButton = node("mapy-map-button");
		this._zoomOutButton.appendChild(createSDSIcon({ symbol: ICON_REMOVE_24 }));
		this._zoomOutButton.addEventListener("click", this, false);
		zoomGroup.appendChild(this._zoomOutButton);
		this._zoomInButton = node("mapy-map-button");
		this._zoomInButton.appendChild(createSDSIcon({ symbol: PLUS_24 }));
		this._zoomInButton.addEventListener("click", this, false);
		zoomGroup.appendChild(this._zoomInButton);
		this._node = zoomGroup;
		this._onZoom = onZoom;
	}

	destroy() {
		this._zoomInButton.removeEventListener("click", this, false);
		this._zoomOutButton.removeEventListener("click", this, false);
	}

	getContainer() {
		return this._node;
	}

	set zoomIn(value: boolean) {
		this._zoomInButton.disabled = value;
	}

	set zoomOut(value: boolean) {
		this._zoomOutButton.disabled = value;
	}

	handleEvent(event: PointerEvent) {
		if (event.target === this._zoomInButton || event.target === this._zoomOutButton) {
			this._onZoom(event.target === this._zoomInButton ? 1 : -1);
		}
	}
}
